import { render, staticRenderFns } from "./InterProcessConfigurationForm.vue?vue&type=template&id=24452a78&"
import script from "./InterProcessConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./InterProcessConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24452a78')) {
      api.createRecord('24452a78', component.options)
    } else {
      api.reload('24452a78', component.options)
    }
    module.hot.accept("./InterProcessConfigurationForm.vue?vue&type=template&id=24452a78&", function () {
      api.rerender('24452a78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/InterProcess/InterProcessConfigurationForm.vue"
export default component.exports